import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";

var root = $.from_html(`<div class="slex-diagram"></div>`);

export default function Diagram($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var div = root();

	$.template_effect(($0) => $.set_attribute(div, 'data-kind', $0), [() => text($.get(p).kind ?? $$props.componentName)]);
	$.append($$anchor, div);
	$.pop();
}